import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Center,
  Text,
  VStack,
  Box,
  Button,
  Flex,
  Input,
  FormLabel,
  FormControl,
  FormErrorMessage,
  useToast,
  InputGroup,
  InputRightElement,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Table,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { ChangeEvent, MouseEvent, useRef, useEffect, useState } from "react";
import { RiSearch2Line } from "react-icons/ri";
import { useNavigate } from "react-router-dom";
import AdminDashboardHeader from "../../components/admin/AdminHeader";
import AdminSidebar from "../../components/admin/AdminSidebar";
import Loading from "../../components/common/Loading";
import adminHelpers from "../../services/admin/admin.service";
import registrationService from "../../services/registration.service";
import { useFormik } from "formik";

const AdminTrainingCalendar = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const inputRef = useRef<HTMLInputElement | null>(null);
  const [uploadFileSize, setUploadFileSize] = useState("");
  const [batchFile, setbatchFile] = useState<File | undefined>();
  const [filename, setFilename] = useState("");
  const [filetype, setFiletype] = useState<string | undefined>("");

  const toast = useToast();

  const handleButtonClick = (e: MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();
    formik.handleSubmit();
  };

  const formik = useFormik({
    validate: (values: any) => {
      const errors: any = {};
      if (!values.name) {
        errors.name = "Title is required";
      }
      return errors;
    },
    initialValues: {
      name: "",
      attachment: "",
    },
    onSubmit: async (values) => {
      const formData = new FormData();
      // Check and append the batchFile if it exists
      if (batchFile) {
        formData.append("attachment", batchFile);
      }

      // Append the rest of the values to the FormData
      formData.append("name", values.name);

      try {
        const basicResponse = await adminHelpers.uploadTrainingCalendar(
          formData
        );
        if (basicResponse) {
          toast({
            title: "Calendar Uploaded ",
            description: `${basicResponse.message}`,
            status: "success",
          });
        } else {
          toast({
            title: "Calendar Uploaded",
            description: `${basicResponse.error} || "Error processing request" `,
            status: "error",
          });
        }
      } catch (error: any) {
        toast({
          title: "Calendar Uploaded ",
          description: `${error.response.data.message}`,
          status: "error",
        });
      }
    },
  });

  function isImage(file: any) {
    // Get the file name
    const fileName = file.name.toLowerCase();

    // Supported image file extensions
    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp"];

    // Check if the file name ends with any of the image extensions
    for (const ext of imageExtensions) {
      if (fileName.endsWith(ext)) {
        return true; // It's an image file
      }
    }

    // If the file type is not in the list of image extensions
    return false;
  }
  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.files;

    if (value) {
      const selectedFile = value[0];

      if (selectedFile && isImage(selectedFile)) {
        const fileName = e.target.files?.item(0)?.name as string;
        setFilename(fileName);
        const fileType = e.target.files?.item(0)?.type;
        setFiletype(fileType);
        const file = e.target.files?.item(0) as File;

        setbatchFile(file);
      } else {
        formik.errors.attachment = "Please upload an image";
        throw new Error("Please select an image file");
      }
    }
  };

  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Flex>
          <Box width="18%" position="fixed" top="0" left="0" zIndex="1">
            <AdminSidebar />
          </Box>

          <Box width="82%" ml="18%">
            <AdminDashboardHeader />
            <Box
              bg="#F9F8F8"
              minHeight="90vh"
              height="auto"
              pb="1rem"
              pt="30px"
              pl="20px"
              pr="40px"
            >
              <Flex
                justifyContent="space-between"
                alignItems="center"
                py="26px"
              >
                <Box color="#2B2B2B" fontWeight="800" fontSize="27px">
                  Training Calendar
                </Box>
              </Flex>

              <Center width="100%" bg="#F9F9F9" height="auto">
                <VStack
                  spacing="1rem"
                  fontSize="16px"
                  borderRadius="4px"
                  bg="white"
                  height="fit-content"
                  width={["90%", "70%", "50%", "50%"]}
                  paddingY={"2rem"}
                  paddingX={["1.2rem", "2rem", "2rem", "4rem"]}
                  direction="column"
                  justifyContent="center"
                  border={"0.1px solid #9E9E9E"}
                >
                  <Text
                    // fontSize={["22px", "22px", "25px", "30px"]}
                    fontSize={["18px", "18px", "21px", "26px"]}
                    fontWeight="600"
                    textAlign="center"
                  >
                    Upload Image File
                  </Text>

                  <FormControl
                    mt={6}
                    isInvalid={
                      formik.errors.name && formik.touched.name ? true : false
                    }
                  >
                    <FormLabel
                      mb="1rem"
                      fontWeight="600"
                      fontSize={["15px", "15px", "15px", "16px"]}
                    >
                      Title{" "}
                    </FormLabel>
                    <Input
                      type="text"
                      placeholder="Enter title"
                      name="name"
                      onChange={formik.handleChange}
                    />
                    <FormErrorMessage fontSize={12}>
                      {formik.errors.name}
                    </FormErrorMessage>
                  </FormControl>

                  {filename && (
                    <Box>
                      <Table variant="unstyled">
                        <Thead fontWeight="semibold">
                          <Tr color="brand.subtitle" fontSize={14}>
                            <Td>Filename</Td>
                            <Td>Type</Td>

                            <Td>Size</Td>
                          </Tr>
                        </Thead>

                        <Tbody>
                          <Tr fontSize={13} color="brand.subtitle">
                            <Td maxW="20em">{filename}</Td>
                            <Td>Image</Td>
                            <Td>{uploadFileSize}</Td>
                          </Tr>
                        </Tbody>
                      </Table>
                    </Box>
                  )}
                  <FormControl mt={6}>
                    {!filename && (
                      <FormLabel fontWeight="600" color="#616161" fontSize={15}>
                        Image file
                      </FormLabel>
                    )}
                    <input
                      accept="image/*"
                      type="file"
                      name="attachment"
                      ref={inputRef}
                      onChange={(e) => handleFileChange(e)}
                      style={{ display: "none" }}
                    ></input>
                    <Input
                      cursor="pointer"
                      placeholder="No file selected"
                      defaultValue={filename}
                      mt="10px"
                      borderColor="#eeeeee"
                      fontSize={14}
                      bg="#fafafa"
                      onClick={() => inputRef?.current?.click()}
                      border="1px dashed"
                      borderRadius={2}
                    />

                    <FormErrorMessage fontSize={12}>
                      {" "}
                      {formik.errors.attachment}{" "}
                    </FormErrorMessage>
                  </FormControl>

                  {/* <FormControl>
                      <FormLabel mb="1rem">Email Address <Text as="span" color="red">*</Text></FormLabel>
                      <Input placeholder="Enter Email Adress" />
                  </FormControl> */}
                  <Flex
                    width="100%"
                    justifyContent="flex-end"
                    fontFamily="Manrope"
                  >
                    <Button
                      position="relative"
                      lineHeight="130%"
                      mt="2.4rem"
                      colorScheme="red"
                      width="8rem"
                      height="2.2rem"
                      textTransform="uppercase"
                      paddingY="1.2rem"
                      paddingX="1.2rem"
                      borderRadius="0px"
                      type="submit"
                      isLoading={formik.isSubmitting}
                      onClick={handleButtonClick}
                      fontSize={"14px"}
                    >
                      SUBMIT
                    </Button>
                  </Flex>
                </VStack>
              </Center>
            </Box>
          </Box>
        </Flex>
      )}
    </>
  );
};

export default AdminTrainingCalendar;
